import { AuthenticatedLayout } from "../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { RemittanceYearToDate } from "../../components/RemittanceYearToDate";

export const RemittanceYearToDatePage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Remittance"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[]}
      mainContents={<RemittanceYearToDate />}
    />
  );
};
